import React from 'react';
import ReactToggle, { ToggleProps } from 'react-toggle';

import block from 'propmods';

import './Toggle.scss';

const b = block('Toggle');

const Toggle: React.FC<ToggleProps> = (props) => {
    return (
        <div {...b()}>
            <ReactToggle {...props} />
        </div>
    );
};

export default Toggle;
